import * as model from '../../models';
import { CheckoutActions } from "./checkout.actions"

export interface CheckoutState {
	customer: model.Customer;
	billingAddress: model.Address;
	shippingAddress: model.Address;
	paymentType: string;
	shipmentType: string;
	lastPlacedOrder: any;
	errorMessages: model.ErrorMessages;
	documentsToPrint: model.DocumentsToPrint;
	ticketPrinterId: string;
	availableShipmentTypesInfo: model.AvailableShipmentTypeDTO;
};

const initialState: CheckoutState  = {
	customer: null,
	billingAddress: null,
	shippingAddress: null,
	paymentType: null,
	shipmentType: null,
	lastPlacedOrder : null,
	errorMessages: {
		paymentErrors: [],
		shipmentErrors: [],
		ticketPrinterErrors: []
	},
	documentsToPrint: {
		ticketPrint: true,
		coverLetterPrint: false,
		invoicePrint: false,
		pdfTickets: false
	},
	ticketPrinterId: "",
	availableShipmentTypesInfo: null
}

const isPostalAddressCorrect = (address: model.Address) => {
	if ((address.city) && (address.postalCode) && (address.street)) {
		return true
	}
	return false
}

export const checkShipmentData = (state: CheckoutState): string[] => {
	let msg = []
	if (((state.shipmentType === "POST") || (state.shipmentType === "EMAIL") || (state.shipmentType === "PICKUP")) && (!state.customer)) {
		msg.push("Bitte einen Kunden auswählen.")
	}
	if ((state.shipmentType === "POST") && (state.customer) && (!isPostalAddressCorrect(state.shippingAddress))) {

		msg.push("Die gewählte Versandadresse ist nicht vollständig (Ort, PLZ und Straße sind Pflicht).")
	}
	if ((state.shipmentType === "EMAIL") && (state.customer) && (!state.shippingAddress.email)) {

		msg.push("In der Versandadresse fehlt eine E-Mail-Adresse, welche für die gewählte Versandart benötigt wird.")
	}
	return msg
}

export const checkTicketPrinterData = (state: CheckoutState): string[] => {
	let msg = []
	if ((state.documentsToPrint.ticketPrint) && (state.ticketPrinterId === "")) {
		msg.push("Bitte einen Ticketdrucker auswählen")
	}
	return msg
}

export const checkoutReducer = (state: CheckoutState = initialState, action): CheckoutState => {
	switch (action.type) {
		case (CheckoutActions.SET_CUSTOMERS): {
			let customer: model.Customer = action.payload;
			let newState =  {
				customer: customer,
				billingAddress: customer.defaultBillingAddress,
				shippingAddress: customer.defaultShippingAddress,
				shipmentType: state.shipmentType,
				paymentType: state.paymentType,
				lastPlacedOrder: null,
				errorMessages: state.errorMessages,
				documentsToPrint: state.documentsToPrint,
				ticketPrinterId: state.ticketPrinterId,
				availableShipmentTypesInfo: state.availableShipmentTypesInfo
			}
			return Object.assign({}, newState, {
				errorMessages: {
					paymentErrors: newState.errorMessages.paymentErrors,
					shipmentErrors: checkShipmentData(newState),
					ticketPrinterErrors: newState.errorMessages.ticketPrinterErrors
				}
			})
		}
		case (CheckoutActions.REMOVE_CUSTOMER): {
			let newState = {
				customer: null,
				billingAddress: null,
				shippingAddress: null,
				shipmentType: state.shipmentType,
				paymentType: state.paymentType,
				lastPlacedOrder: null,
				errorMessages: state.errorMessages,
				documentsToPrint: state.documentsToPrint,
				ticketPrinterId: state.ticketPrinterId,
				availableShipmentTypesInfo: state.availableShipmentTypesInfo
			}
			return Object.assign({}, newState, {
				errorMessages: {
					paymentErrors: newState.errorMessages.paymentErrors,
					shipmentErrors: checkShipmentData(newState),
					ticketPrinterErrors: newState.errorMessages.ticketPrinterErrors
				}
			})
		}
		case (CheckoutActions.SET_BILLING_ADDRESS): {
			let newState = Object.assign({}, state, { billingAddress: action.payload })
			return newState
		}
		case (CheckoutActions.SET_SHIPPING_ADDRESS): {
			let newState = Object.assign({}, state, { shippingAddress: action.payload })
			return Object.assign({}, newState, {
				errorMessages: {
					paymentErrors: newState.errorMessages.paymentErrors,
					shipmentErrors: checkShipmentData(newState),
					ticketPrinterErrors: newState.errorMessages.ticketPrinterErrors
				}
			})
		}
		case (CheckoutActions.SET_PAYMENT_TYPE): {
			let newState = Object.assign({}, state, { paymentType: action.payload })
			return Object.assign({}, newState, {
				errorMessages: {
					paymentErrors: newState.errorMessages.paymentErrors,
					shipmentErrors: checkShipmentData(newState),
					ticketPrinterErrors: newState.errorMessages.ticketPrinterErrors
				}
			})
		}
		case (CheckoutActions.SET_SHIPMENT_TYPE): {
			let newState = Object.assign({}, state, { shipmentType: action.payload })
			return Object.assign({}, newState, {
				errorMessages: {
					paymentErrors: newState.errorMessages.paymentErrors,
					shipmentErrors: checkShipmentData(newState),
					ticketPrinterErrors: newState.errorMessages.ticketPrinterErrors
				}
			})
		}
		case (CheckoutActions.SET_DOCUMENTS_TO_PRINT): {
			let newState = Object.assign({}, state, { documentsToPrint: action.payload })
			return Object.assign({}, newState, {
				errorMessages: {
					paymentErrors: newState.errorMessages.paymentErrors ,
					shipmentErrors: newState.errorMessages.shipmentErrors,
					ticketPrinterErrors: checkTicketPrinterData(newState)
				}
			})
		}
		case (CheckoutActions.SET_TICKET_PRINTER): {
			let newState = Object.assign({}, state, { ticketPrinterId: action.payload })
			return Object.assign({}, newState, {
				errorMessages: {
					paymentErrors: newState.errorMessages.paymentErrors ,
					shipmentErrors: newState.errorMessages.shipmentErrors,
					ticketPrinterErrors: checkTicketPrinterData(newState)
				}
			})
		}
		case (CheckoutActions.ORDER_PLACED): {
			console.log("PAYLOAD:::", action.payload)
			return Object.assign({}, state, {
				customer: null,
				billingAddress: null,
				shippingAddress: null,
				paymentType: "CASH",
				shipmentType: "CARRY",
				lastPlacedOrder: action.payload,
				errorMessages: {
					paymentErrors: [],
					shipmentErrors: [],
					ticketPrinterErrors: []
				}
			});
		}
		case (CheckoutActions.LOAD_AVAILABLE_SHIPMENTTYPES_SUCCESS): {
			console.log("PAYLOAD:::", action.payload)
			return Object.assign({}, state, {
				availableShipmentTypesInfo: action.payload
			});
		}

		default: return state
	}
}




// WEBPACK FOOTER //
// ./src/app/components/checkout-components/checkout.reducer.ts